export default __webpack_public_path__ + "static/media/kamal-garg.e2ac7af2.png";